import smoothscroll from 'smoothscroll-polyfill';

// 是否是本地开发环境
/* eslint-disable no-undef */
export const isDev = NODE_ENV === 'development';

// 嵌入iframe时的页面跳转
export const inFlowIframeJump = url => {
    try {
        if (window.parent) {
            window.parent.postMessage({ type: 'timeline/jump', value: url }, '*');
        }
    } catch (e) {
        console.error(e);
    }
};

// 嵌入iframe时的页面高度变化:注意参数，传入的参数为字符串，不能为对象
export const inFlowIframeResize = height => {
    try {
        if (window.parent) {
            window.parent.postMessage({ type: 'timeline/resize', value: height }, '*');
        }
    } catch (e) {
        console.error(e);
    }
};

// 判断是否在iOS
export const isIOS = () => {
    const u = window.navigator.userAgent;

    return !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
};

// 判断是否在微信环境（不包括企业微信）
export const isWeChat = () => {
    const ua = window.navigator.userAgent.toLowerCase();
    const isWx = ua.indexOf('micromessenger') !== -1;
    const isWxWork = ua.indexOf('wxwork') !== -1;

    return isWx && !isWxWork;
};

// hex转rgba
export const hexToRgba = (hex, opacity) => {
    let c = '';

    if (/^#([A-Fa-f0-9]{3}){1,2}$/.test(hex)) {
        c = hex.substring(1).split('');
        if (c.length === 3) {
            c = [c[0], c[0], c[1], c[1], c[2], c[2]];
        }
        c = `0x${c.join('')}`;

        return `rgba(${[(c >> 16) & 255, (c >> 8) & 255, c & 255].join(',')},${opacity})`;
    } else {
        return hex;
    }
};

export const getScrollParent = node => {
    const regex = /(auto|scroll)/;
    const parents = (_node, ps) => {
        if (_node.parentNode === null) {
            return ps;
        }

        return parents(_node.parentNode, ps.concat([_node]));
    };

    const style = (_node, prop) => getComputedStyle(_node, null).getPropertyValue(prop);
    const overflow = _node => style(_node, 'overflow') + style(_node, 'overflow-y') + style(_node, 'overflow-x');
    const scroll = _node => regex.test(overflow(_node));

    const scrollParent = _node => {
        if (!(_node instanceof HTMLElement || _node instanceof SVGElement)) {
            return;
        }

        const ps = parents(_node.parentNode, []);

        for (let i = 0; i < ps.length; i += 1) {
            if (scroll(ps[i])) {
                return ps[i];
            }
        }

        return document.scrollingElement || document.documentElement;
    };

    return scrollParent(node);
};

export const smoothScroll = (target, top) => {
    smoothscroll.polyfill();

    target.scroll({ top, left: 0, behavior: 'smooth' });
};

export const smoothScrollIntoView = target => {
    smoothscroll.polyfill();

    target.scrollIntoView({ behavior: 'smooth', block: 'center' });
};
